import React, { Component, Fragment } from 'react'
import { Chat, HelpHeaderDetailed, MainContainer, ElementNotFound, PrivacyMessage } from './customComponents'
import FICRestV2 from 'FICRestV2'
import BreadCrumbs from './BreadCrumbs'
import { BulletList } from 'react-content-loader'
import styled, { ThemeProvider } from 'styled-components'
import FICColors from 'FICColors'

export default class Section extends Component {
  constructor (props) {
    super(props)
    this.state = {
      section: false,
      articles: [],
      chat: [],
      elementNotFound: false
    }
    this.loadData()
  }

  componentDidMount () {
    const node = ReactDOM.findDOMNode(this)

    if (this.props.isExternal) {
      const mainContainer = node.parentNode.parentNode.parentNode
      mainContainer.scrollTop = 0
    }
  }

  componentDidUpdate (prevProp) {
    if (this.props.searchKey !== prevProp.searchKey) {
      this.loadData(this.props.searchKey)
    }
  }

  loadData = (id) => {
    const searchedId = id || this.props.searchKey
    FICRestV2.get({
      request: 'help/list/' + searchedId,
      queryData: { realm: this.props.realm, is_dev: window.location.host.includes('-dev') ? 1 : 0 },
      onSuccess: (response) => {
        let newData = Object.assign({}, response.data)
        newData.elementNotFound = !response.data.section
        this.setState(newData)
      }
    })
  }

  getBreadCrumbs = () => {
    let breadCrumbPaths = []
    let c = 2
    while (c >= 1) {
      if (this.state.tree && this.state.tree[ 'section' + c + '_permalink' ]) {
        const permalink = this.state.tree[ 'section' + c + '_permalink' ]
        breadCrumbPaths.push({ text: this.state.tree[ 'section' + c + '_title' ], onClick: () => this.props.changeView(permalink, 'sezione') })
      }
      c--
    }
    if (this.state.section) {
      breadCrumbPaths.push({ text: this.state.section.title })
    }
    return breadCrumbPaths
  }

  render () {
    return (
      <MainContainer
        className={this.props.className}
        isExternal={this.props.isExternal}
      >
        <HelpHeaderDetailed
          closeIcon={!this.props.embedded}
          onClickClose={this.props.onClickClose}
          onClick={() => this.props.changeView(undefined, 'main')}
          title={this.state.section ? this.state.section.title : ''}
          description={this.state.section && this.state.section.description ? this.state.section.description : ''}
          isExternal={this.props.isExternal}
          realm={this.props.realm}
          embedded={this.props.embedded}
        />
        <BreadCrumbs
          onSelect={this.props.changeView}
          paths={this.getBreadCrumbs()}
          className='breadCrumbs'
          realm={this.props.realm}
          embedded={this.props.embedded}
        />
        {!this.state.section
          ? this.state.elementNotFound
            ? <ElementNotFound type='section' onClick={this.props.changeView} />
            : <SectionLoading isExternal={this.props.isExternal} />
          : <Fragment>
            {this.state.articles && this.state.articles.length > 0 &&
            <SectionContainer 
              isExternal={this.props.isExternal}
              className={`sectionContainer ${this.props.embedded ? 'embeddedSection' : ''} `}
            >
              <SectionList>

                <Fragment>
                  <h2>Generali</h2>
                  <ul>
                    {this.state.articles.map((article, idx) => {
                      return (
                        <li key={idx} onClick={() => this.props.changeView(article.permalink, 'articolo')}>
                          <span>{article.title}</span>
                        </li>
                      )
                    })}
                  </ul>
                </Fragment>
              </SectionList>
            </SectionContainer>
            }
            {this.state.subSections && this.state.subSections.length > 0 &&
            this.state.subSections.map((subSection, idx) => {
              return (
                <SectionContainer 
                  isExternal={this.props.isExternal}
                  key={idx} 
                  className={`sectionContainer ${this.props.embedded ? 'embeddedSection' : ''}`}
                >
                  <SectionList>
                    <h2>{subSection.title}</h2>
                    {subSection.articles &&
                    <ul>
                      {subSection.articles.map((article, idx) => {
                        return (
                          <li key={idx} onClick={() => this.props.changeView(article.permalink, 'articolo')}>
                            <span>{article.title}</span>
                          </li>
                        )
                      })}
                    </ul>
                    }

                    {subSection.subSections.length > 0 &&
                    subSection.subSections.map((subSubSection, subIdx) => {
                      return (
                        <SectionList key={subIdx}>
                          <h3>{subSubSection.title}</h3>
                          {subSubSection.articles &&
                          <ul>
                            {subSubSection.articles.map((subArticle, subAIdx) => {
                              return (
                                <li key={subAIdx} onClick={() => this.props.changeView(subArticle.permalink, 'articolo')}>
                                  <span>{subArticle.title}</span>
                                </li>
                              )
                            })}
                          </ul>
                          }
                        </SectionList>
                      )
                    })}
                  </SectionList>
                </SectionContainer>
              )
            })
            }
          </Fragment>
        }
        {this.state.chat.open && reactGlobalParams.chat.help_visible && !this.state.elementNotFound &&
        <Fragment>
          <Chat warning={this.state.chat.warning} type='section' id={this.state.section.id} />
          <PrivacyMessage isFic={this.props.realm === 'fic'} />
        </Fragment>
        }
      </MainContainer>
    )
  }
}

const SectionsContainerImpl = ({ className, ...props }) => <div className={className}>{props.children}</div>
const SectionContainer = styled(SectionsContainerImpl)`
  max-width: 940px;
  margin: 0 auto;
  padding: 24px 16px;
  border-bottom:1px solid rgba(51,51,51,0.08);
  &:last-child{
    border: none;
  }
`

const SectionListImpl = ({ className, ...props }) => <div className={className + ' sectionList'}>{props.children}</div>
const SectionList = styled(SectionListImpl)`
  .sectionList{margin-top: 35px}
  h2{
    font-size: 30px;
    font-weight: bold;
    @media (max-width: 425px) {
      font-size: 22px;
    }
  }
  h3{
    font-size: 20px;
    font-weight: bold;
  }
  ul{
    margin:20px 0 0 10px;
    li{
      color: ${FICColors.textDefault};
      margin-bottom: 20px;
      margin-left:10px;
      font-size: 16px;
      line-height: 24px;
      &:last-child{margin-bottom: 0}
      span{
        cursor: pointer;
        color: ${FICColors.textLink};
        &:hover{
          text-decoration: underline;
          &::before {text-decoration: none;}
        }
      }
    }
  }
`

const SectionLoadingSvg = ({ className, ...props }) => <div className={className + ' sectionListLoading'}>
  <BulletList className='bulletList' />
</div>
const SectionLoading = styled(SectionLoadingSvg)`
  width: 100%;
  height:160px;
  margin: 35px auto;
  max-width: 940px;
  display: block;
  .bulletList{width: 400px}
`



// WEBPACK FOOTER //
// ./src/help/common/Section.js